import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote-group";
import * as z from "zod/v4";

export const createToteGroup = {
  name: "createToteGroup" as const,
  input: z.object({ name: z.string() }),
  output: RedoFulfillmentToteGroupSchema,
};
